import { Injectable } from '@angular/core';
import { ApiService, DataService, OfflineApiService, LogService } from '../../../shared/services';
import { CustomerSelectorPluginService } from '../../customerselector/customerselector-plugin.service';
import { InstallationCustomerInfoFactoryPluginService } from './customer-info-plugin-factory.service';

@Injectable()
export class InstallationCustomerInfoPluginService extends CustomerSelectorPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    protected logService: LogService,
    offlineApi: OfflineApiService,
    customerFactory: InstallationCustomerInfoFactoryPluginService
  ) {
    super(apiService, dataService, offlineApi, customerFactory, logService);
  }
}
